import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "download-session-panel"
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "sessions-list q-px-sm q-pt-xs" }
const _hoisted_4 = { class: "row items-center q-mb-xs" }
const _hoisted_5 = {
  key: 0,
  class: "text-caption text-grey-6 q-mb-xs row items-center"
}
const _hoisted_6 = { class: "absolute-full flex flex-center" }
const _hoisted_7 = {
  class: "text-caption text-grey-6",
  style: {"font-size":"10px"}
}
const _hoisted_8 = {
  key: 0,
  class: "q-ml-xs text-grey-8"
}
const _hoisted_9 = {
  key: 0,
  class: "text-caption text-light-blue",
  style: {"font-size":"10px"}
}
const _hoisted_10 = {
  key: 1,
  class: "text-caption text-red"
}
const _hoisted_11 = {
  key: 2,
  class: "text-caption text-orange"
}
const _hoisted_12 = {
  key: 2,
  class: "text-caption text-grey-7 q-mt-xs session-message"
}
const _hoisted_13 = {
  key: 0,
  class: "passage-section q-px-sm q-pb-sm"
}
const _hoisted_14 = { class: "row items-center q-mb-xs" }
const _hoisted_15 = { class: "text-caption text-weight-medium text-grey-7" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_table = _resolveComponent("q-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.panelVisible && _ctx.sessionCount > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_icon, {
            name: "cloud_download",
            size: "sm",
            class: "q-mr-xs"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "panel-title" }, "Download Sessions", -1)),
          _createVNode(_component_q_space),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            round: "",
            icon: "close",
            size: "sm",
            onClick: _ctx.closePanel
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSessions, (s) => {
            return (_openBlock(), _createElementBlock("div", {
              key: s.downloadSessionId,
              class: "session-card q-mb-xs q-pa-xs"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_icon, {
                  name: _ctx.sessionStateIcon(s),
                  color: _ctx.sessionStateColor(s),
                  size: "xs",
                  class: "q-mr-xs"
                }, null, 8, ["name", "color"]),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-caption text-weight-medium", `text-${_ctx.sessionStateColor(s)}`])
                }, _toDisplayString(_ctx.sessionStateLabel(s)) + " — UID " + _toDisplayString(s.uid), 3),
                _createVNode(_component_q_space),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "history",
                  size: "xs",
                  class: "text-grey-7",
                  onClick: ($event: any) => (_ctx.openDeviceHistoryForSession(s))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("Device History", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (s.downloadSessionId < 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_q_spinner, {
                      color: "grey-6",
                      size: "14px",
                      class: "q-mr-xs"
                    }),
                    _cache[2] || (_cache[2] = _createTextVNode(" Waiting for the device to respond ", -1))
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_q_linear_progress, {
                      value: s.percentComplete / 100,
                      color: _ctx.sessionProgressColor(s),
                      stripe: s.state === 'T',
                      "animation-speed": s.state === 'T' ? 300 : 0,
                      rounded: "",
                      size: "18px",
                      class: _normalizeClass(["q-mb-xs progress-bar", { 'progress-bar--active': s.state === 'T' }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_q_badge, {
                            color: "white",
                            "text-color": "dark",
                            label: `${s.percentComplete}%`,
                            class: _normalizeClass({ 'badge-pulse': s.state === 'T' })
                          }, null, 8, ["label", "class"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value", "color", "stripe", "animation-speed", "class"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(s.startDate)) + " — " + _toDisplayString(_ctx.formatDate(s.endDate)) + " ", 1),
                      (s.passageCount > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(s.passageCount) + " passages) ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (
              s.latestPassageTimestamp && (s.state === 'T' || s.state === 'D')
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_q_icon, {
                            name: "schedule",
                            size: "12px",
                            class: "q-mr-xs"
                          }),
                          _createTextVNode(" Latest downloaded timestamp: " + _toDisplayString(_ctx.formatDate(s.latestPassageTimestamp)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (s.state === 'X')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Timed out — device may be offline. "))
                      : (s.state === 'A')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Cancelled — superseded by a newer download or stop command. "))
                        : _createCommentVNode("", true)
                  ], 64)),
              (s.message)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_q_icon, {
                      name: "info",
                      size: "12px",
                      class: "q-mr-xs"
                    }),
                    _createTextVNode(" " + _toDisplayString(s.message), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (_ctx.allPassages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, " Passages (" + _toDisplayString(_ctx.allPassages.length) + ") ", 1)
              ]),
              (_ctx.allPassages.length > 0)
                ? (_openBlock(), _createBlock(_component_q_table, {
                    key: 0,
                    rows: _ctx.allPassages,
                    columns: _ctx.passageColumns,
                    "row-key": "passageId",
                    dense: "",
                    flat: "",
                    "rows-per-page-options": [5, 10, 25],
                    class: "passage-table"
                  }, {
                    "body-cell-uid": _withCtx((props) => [
                      _createVNode(_component_q_td, { props: props }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(props.row.uid), 1)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    "body-cell-graph-data": _withCtx((props) => [
                      _createVNode(_component_q_td, { props: props }, {
                        default: _withCtx(() => [
                          ((props.row.passageWaveforms || []).length === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                  return (_openBlock(), _createBlock(_component_q_btn, {
                                    key: wf.passageWaveformId,
                                    size: "sm",
                                    class: "q-mr-xs btn-brand",
                                    dense: "",
                                    icon: "show_chart",
                                    label: _ctx.getWaveformLabel(wf.passageWaveformType),
                                    onClick: ($event: any) => (_ctx.showChart(props, wf))
                                  }, null, 8, ["label", "onClick"]))
                                }), 128))
                              ]))
                            : ((props.row.passageWaveforms || []).length > 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                  _createVNode(_component_q_btn_dropdown, {
                                    size: "sm",
                                    class: "q-mr-xs btn-brand",
                                    dense: "",
                                    icon: "show_chart"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_list, { dense: "" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms, (wf) => {
                                            return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                              key: wf.passageWaveformId,
                                              clickable: "",
                                              onClick: ($event: any) => (_ctx.showChart(props, wf))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_item_label, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.getWaveformLabel(wf.passageWaveformType)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])), [
                                              [_directive_close_popup]
                                            ])
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    "body-cell-machine-learning-data": _withCtx((props) => [
                      _createVNode(_component_q_td, { props: props }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.passageWaveforms || [], (wf) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (wf.mlConfidence != null)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: wf.passageWaveformId,
                                    size: "sm",
                                    style: {"width":"70px","max-width":"5vw"},
                                    class: "q-mr-xs btn-brand q-pr-xs",
                                    dense: "",
                                    color: _ctx.getMLColor(wf.mlPrediction, wf.mlConfidence),
                                    icon: _ctx.getMLIcon(_ctx.getMLColor(wf.mlPrediction, wf.mlConfidence)),
                                    label: _ctx.getMLConfidenceLabel(wf.mlPrediction, wf.mlConfidence)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_tooltip, {
                                        anchor: "center middle",
                                        self: "center middle"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" ML Process Type: " + _toDisplayString(_ctx.getWaveformLabel(wf.passageWaveformType)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["color", "icon", "label"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 2
                      }, 1032, ["props"])
                    ]),
                    _: 1
                  }, 8, ["rows", "columns"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}